import axios from 'axios'

const API_URL = '/admin/collections'

class CollectionService {
    /**
     * Get list of all collections
     * @param {Object} params - Query parameters (search, is_active, per_page)
     * @returns {Promise}
     */
    list(params = {}) {
        return axios.get(API_URL, { params })
    }

    /**
     * Get single collection by ID
     * @param {Number|String} id - Collection ID
     * @returns {Promise}
     */
    get(id) {
        return axios.get(`${API_URL}/${id}`)
    }

    /**
     * Create new collection
     * @param {FormData|Object} data - Collection data
     * @returns {Promise}
     */
    create(data) {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        return axios.post(API_URL, data, config)
    }

    /**
     * Update existing collection
     * @param {Number|String} id - Collection ID
     * @param {FormData|Object} data - Collection data
     * @returns {Promise}
     */
    update(id, data) {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        // Using POST instead of PUT to support file uploads
        return axios.post(`${API_URL}/${id}`, data, config)
    }

    /**
     * Delete collection
     * @param {Number|String} id - Collection ID
     * @returns {Promise}
     */
    remove(id) {
        return axios.delete(`${API_URL}/${id}`)
    }

    /**
     * Update sort order for multiple collections
     * @param {Object} data - Object with items array
     * @returns {Promise}
     */
    updateSortOrder(data) {
        return axios.post(`${API_URL}/sort-order`, data)
    }

    /**
     * Toggle collection active status
     * @param {Number|String} id - Collection ID
     * @param {Boolean} isActive - New active status
     * @returns {Promise}
     */
    async toggleActive(id, isActive) {
        const collection = await this.get(id)
        return this.update(id, {
            ...collection.data,
            is_active: isActive
        })
    }
}

export default new CollectionService()